/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'doctrine/reduce_maintenance_2': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M28 12.646V4h-8.646L16 .646 12.646 4H4v8.646L.646 16 4 19.354V28h8.646L16 31.354 19.354 28H28v-8.646L31.354 16 28 12.646zm-24 6L1.354 16 4 13.354v5.292zM16 1.354L18.646 4h-5.293L16 1.354zm-.458 6.619V15.5H8.015l7.527-7.527zM8.015 16.5h7.527v7.527L8.015 16.5zM16 30.646L13.354 28h5.292L16 30.646zm.542-6.703V16.5h7.442l-7.442 7.443zm0-8.443V8.057l7.442 7.443h-7.442zM28 13.353L30.646 16 28 18.646v-5.293z"/>'
  }
})
